import React, { useState } from 'react';

export const CustomDropdown = ({ meals, onSelect, selected, isDisabled, mealsForDisable }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedItem, setSelectedItem] = useState(selected);
  const filteredItems = meals.filter(meal =>
    meal?.name.toLowerCase().includes(searchTerm.toLowerCase()) &&
    !mealsForDisable?.includes(meal?.id)
  );

  const toggleDropdown = () => {
    if (!isDisabled) {
      setIsOpen(prevState => !prevState);
    }
  };

  const handleSelect = (meal) => {
    if (!isDisabled) {
      setSelectedItem(meal);
      setIsOpen(false);
      setSearchTerm('');
      onSelect(meal);
    }
  };



  return (
    <div style={{ position: 'relative', width: '100%' }}>
      {/* Dropdown Input */}
      <div
        onClick={toggleDropdown}
        style={{
          width: '100%',
          padding: '12px 16px',
          border: `1px solid ${isDisabled ? '#ccc' : '#d1d1d1'}`,
          borderRadius: '8px',
          cursor: isDisabled ? 'not-allowed' : 'pointer',
          backgroundColor: isDisabled ? 'rgb(230,233,236)' : '#f9f9f9',
          color: isDisabled ? '#999' : '#333',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          transition: 'border-color 0.3s ease',
        }}
      >
        <span>{selectedItem ? selectedItem?.name : 'Επιλέξτε Γεύμα'}</span>
        <span style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s ease' }}>
          ▼
        </span>
      </div>

      {/* Search Input and Dropdown Menu */}
      {isOpen && !isDisabled && (
        <div
          style={{
            position: 'absolute',
            width: '100%',
            top: '110%',
            left: 0,
            border: '1px solid #d1d1d1',
            backgroundColor: 'white',
            zIndex: 10,
            borderRadius: '8px',
            maxHeight: '200px',
            overflowY: 'auto',
            boxShadow: '0px 6px 12px rgba(0, 0, 0, 0.1)',
            padding: '8px 0',
          }}
        >
          <input
            type="text"
            placeholder="Αναζήτηση..."
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            disabled={isDisabled}
            spellCheck='false'
            style={{
              width: '100%',
              padding: '12px',
              boxSizing: 'border-box',
              border: 'none',
              borderBottom: '1px solid #d1d1d1',
              outline: 'none',
              marginBottom: '8px',
              fontSize: '14px',
              backgroundColor: isDisabled ? '#f5f5f5' : 'white',
              color: isDisabled ? '#999' : '#333',
            }}
          />

          {/* List of meals */}
          {filteredItems.length > 0 ? (
            filteredItems.map(meal => (
              <div
                key={meal.id}
                onClick={() => handleSelect(meal)}
                style={{
                  padding: '10px 16px',
                  cursor: isDisabled ? 'not-allowed' : 'pointer',
                  backgroundColor: selectedItem?.id === meal.id ? '#e6f7ff' : 'white',
                  transition: 'background-color 0.2s ease',
                  color: isDisabled ? '#999' : '#333',
                  fontSize: '14px',
                  fontWeight: selectedItem?.id === meal.id ? '600' : '400',
                  borderBottom: '1px solid #f1f1f1',
                }}
                onMouseEnter={(e) => !isDisabled && (e.currentTarget.style.backgroundColor = '#f5f5f5')}
                onMouseLeave={(e) => !isDisabled && (e.currentTarget.style.backgroundColor = selectedItem?.id === meal?.id ? '#e6f7ff' : 'white')}
              >
                {meal?.name}
              </div>
            ))
          ) : (
            <div style={{ padding: '10px 16px', textAlign: 'center', color: '#888' }}>No results found</div>
          )}
        </div>
      )}
    </div>
  );
};
